export * from './lib/shared-ui.module';

export * from './lib/components/viewsimple1/viewsimple1.component';

export { Viewsimple1ComponentModule } from './lib/components/viewsimple1/viewsimple1.component';
export { ToggleSwitchButtonComponent } from './lib/components/toggle-switch-button/toggle-switch-button.component';
export { SelectIconsComponent } from './lib/components/select-icons/select-icons.component';

export * from './lib/components/simple-card1/simple-card1.component';
